module.exports = __webpack_public_path__ + "static/media/icn-ledger.cb219791.svg";